import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "strategy-introduction" }
const _hoisted_2 = { class: "strategy-introduction__item" }
const _hoisted_3 = { class: "profile-tag" }
const _hoisted_4 = { class: "profile-tag__content" }
const _hoisted_5 = { class: "profile-tag-no-tag" }
const _hoisted_6 = { class: "strategy-introduction__item" }
const _hoisted_7 = { class: "strategy-introduction__step" }
const _hoisted_8 = { class: "strategy-introduction__step-title joy-mb-2" }
const _hoisted_9 = { class: "strategy-introduction__step-details" }
const _hoisted_10 = { class: "strategy-introduction__step" }
const _hoisted_11 = { class: "strategy-introduction__step-title joy-mb-2" }
const _hoisted_12 = { class: "strategy-introduction__step-details" }
const _hoisted_13 = { class: "strategy-introduction__step" }
const _hoisted_14 = { class: "strategy-introduction__step-title joy-mb-2" }
const _hoisted_15 = { class: "strategy-introduction__step-details" }

import {useTranslation} from '@malt/vue3-use';
    import {useRouter} from 'vue-router';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import {VJoyWrapper} from '@maltjoy/core-vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'IntroductionStep',
  setup(__props) {

    const router = useRouter();
    const {msg} = useTranslation();

    function goNext() {
        router.push({name: router.currentRoute.value.meta.nextStep});
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyButton = _resolveComponent("VJoyButton")!

  return (_openBlock(), _createBlock(Step, {
    "show-stepper": false,
    "progress-bar": false,
    "full-screen": true
  }, {
    "step-content": _withCtx(() => [
      _createVNode(_unref(VJoyWrapper), {
        justify: "center",
        align: "center",
        "no-margin": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.introduction.title.part1')), 1)
              ]),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.introduction.title.part2')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("ol", null, [
                _createElementVNode("li", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(msg)(`profile.creation.wizard.strategy.introduction.step1.title`)), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_unref(msg)(`profile.creation.wizard.strategy.introduction.step1.line.one`)) + " ", 1),
                      _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(msg)(`profile.creation.wizard.strategy.introduction.step1.line.two`)), 1)
                    ])
                  ])
                ]),
                _createElementVNode("li", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(msg)(`profile.creation.wizard.strategy.introduction.step2.title`)), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(msg)(`profile.creation.wizard.strategy.introduction.step2.line.one`)), 1)
                  ])
                ]),
                _createElementVNode("li", _hoisted_13, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(msg)(`profile.creation.wizard.strategy.introduction.step3.title`)), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(msg)(`profile.creation.wizard.strategy.introduction.step3.line.one`)), 1)
                  ])
                ])
              ]),
              _createVNode(_component_VJoyButton, {
                variant: "main",
                "data-testid": "strategy-profile-creation-introduction-cta",
                onClick: goNext
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.wizard.strategy.introduction.cta.label')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})